import { useCallback } from 'react';
import { useHistory } from 'hooks/generic/useHistory';
import { useCheckUserForNftCreation } from './useCheckUserForNftCreation';
import { addQuery } from 'utils/generic/query-route';
import {
  AccountQueryKey,
  EAccountRouteKeys
} from 'constants/account/account-route-keys';

type TOpenCreateNftModal =
  | {
      includeAccountPath?: boolean;
    }
  | undefined;

export const useOpenCreateNftModal = () => {
  const { history } = useHistory();
  const { checkUserForNftCreation, creatorLoaded } = useCheckUserForNftCreation(
    false,
    true
  );

  const openCreateNftModal = useCallback(
    (
      { includeAccountPath }: TOpenCreateNftModal = {
        includeAccountPath: false
      }
    ) => {
      if (!creatorLoaded) return false;
      if (!checkUserForNftCreation()) return false;
      const createNftUrlQuery = addQuery({
        [AccountQueryKey.modal.value]:
          AccountQueryKey.modal.option.CHOOSE_CREATE_NFT
      });

      if (includeAccountPath) {
        history.push({
          pathname: EAccountRouteKeys.ACCOUNT_PROFILE_MY_NFTS_NFTS,
          search: createNftUrlQuery.search
        });
        return true;
      }

      history.push(createNftUrlQuery);
      return true;
    },
    [checkUserForNftCreation, creatorLoaded]
  );

  const closeCreateNftModal = useCallback(() => {
    history.push(addQuery({ [AccountQueryKey.modal.value]: undefined }));
  }, []);

  return { openCreateNftModal, closeCreateNftModal };
};
